module.exports = "images/android-icon-192x192.e8c6767606ca3f9afd21b68b9e936ba5.png";